/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesQuotePriceListResponseDto } from '../../models/sales-quote-price-list-response-dto';

export interface QuotePriceListsControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Optional quote ID to filter quote price lists
 */
  quoteId?: string;
}

export function quotePriceListsControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: QuotePriceListsControllerFindAllByTenant$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>> {
  const rb = new SalesRequestBuilder(rootUrl, quotePriceListsControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('quoteId', params.quoteId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<Array<SalesQuotePriceListResponseDto>>;
    })
  );
}

quotePriceListsControllerFindAllByTenant.PATH = '/o2-sales/quote-price-lists/{tenant}';
